// extracted by mini-css-extract-plugin
export default {"think_green_container":"ThinkGreen_think_green_container__LY8vK","title":"ThinkGreen_title__OcoFJ","tg_desc_clamp":"ThinkGreen_tg_desc_clamp__L0TYb"};